import util from './util';

// Guards against duplicate calls firing within the same page lifecycle.
// React effects can re-trigger this function many times before the browser
// commits the navigation, which would otherwise cancel the in-flight redirect.
// fresh page load reinitializes the module with redirectInFlight = false.
let redirectInFlight = false;

export default function redirectToPlatform() {
  if (redirectInFlight) {
    return;
  }
  redirectInFlight = true;
  const encodedRedirectString = window.btoa(window.location.href);
  const encodedRedirectFromError = window.btoa(document.referrer);
  const encodedRedirectOrigin = window.btoa(window.location.origin);
  const platformBaseURL = util.getPlatformBaseURL();
  let signinRedirectPath = encodedRedirectString;
  if (window.location.pathname === '/error') {
    if (document.referrer === '' || document.referrer === undefined) {
      signinRedirectPath = encodedRedirectOrigin;
    } else {
      signinRedirectPath = encodedRedirectFromError;
    }
  } else if (window.location.pathname === '/sign-up') {
    signinRedirectPath = encodedRedirectOrigin;
  }
  window.location.href = `${platformBaseURL}/login.html?signinRedirect=${signinRedirectPath}`;
}
